export const endpoint = process.env.REACT_APP_API_ENDPOINT || '/api';
export const stripeApiKey = process.env.REACT_APP_STRIPE_API;
